import { ChevronDownIcon } from '@assets/icons/ChevronIcon';
import { PropertyPopover } from '@components/Header/PropertyPopover';
import { cn } from '@components/shadcn/utils';
import CustomSkeleton from '@components/shared/CustomSkeleton';
import { useOrganization } from '@hooks/queries/useOrganization';
import { useProperty } from '@hooks/queries/useProperty';
import { Popover } from 'antd';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

const PropertyTitle = () => {
  const { t } = useTranslation();
  const { property } = useProperty();
  const { organization } = useOrganization();

  if (!property || !organization) {
    return <CustomSkeleton height={20} width={120} />;
  }

  return (
    <span className="font-semibold">{property?.name || t('header.properties.no_selected')}</span>
  );
};

interface PropertySelectorProps {
  propertyPopoverVisible: boolean;
  setPropertyPopoverVisible: Dispatch<SetStateAction<boolean>>;
}

export function PropertySelector({
  propertyPopoverVisible,
  setPropertyPopoverVisible,
}: Readonly<PropertySelectorProps>) {
  const { t } = useTranslation();

  return (
    <Popover
      align={{ offset: [0, 8] }}
      placement="bottomLeft"
      content={<PropertyPopover close={() => setPropertyPopoverVisible(false)} />}
      overlayClassName={
        'pt-0 min-w-[15.62rem] [&_.ant-popover-arrow]:hidden [&_.ant-popover-inner-content]:p-1 [&_.ant-popover-inner]:rounded-md'
      }
      trigger="click"
      visible={propertyPopoverVisible}
      onVisibleChange={(visible) => setPropertyPopoverVisible(visible)}
    >
      <div
        className={
          'max-w-60 flex items-center py-1 px-2 gap-1 rounded cursor-pointer hover:bg-sy-blue-20'
        }
      >
        <div className={'w-11/12 flex flex-col gap-0.5'}>
          <span className="text-xs text-sy-neutral-60">{t('header.properties.title')}</span>
          <span className="truncate">
            <PropertyTitle />
          </span>
        </div>
        <span className={cn('self-end  transition', { 'rotate-180': propertyPopoverVisible })}>
          <ChevronDownIcon />
        </span>
      </div>
    </Popover>
  );
}
